<template>
  <el-card>
    <el-form inline ref="searchInfo" :model="info">
      <el-form-item prop="projectId">
        <el-select v-model="info.projectId" placeholder="请选择公园名称" clearable filterable @change="selectAppoint">
          <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="itemId">
        <el-select v-model="info.itemId" :disabled="!info.projectId" placeholder="请选择预约项目" clearable filterable>
          <el-option v-for="(item, index) in appointList" :key="index" :label="item.itemName"
            :value="item.itemId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="recordStatus">
        <el-select v-model="info.recordStatus" placeholder="请选择预约结果" clearable>
          <el-option label="预约成功" value="0"></el-option>
          <el-option label="预约失败" value="1"></el-option>
          <el-option label="预约取消" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="dateRange">
        <el-date-picker v-model="dateRange" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div class="tips">
      <i class="el-icon-warning-outline"></i>
      预约人数统计： {{ count }} 人
    </div>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="预约项目" show-overflow-tooltip prop="itemName"></el-table-column>
      <el-table-column label="预约人数" show-overflow-tooltip prop="enterNum"></el-table-column>
      <el-table-column label="预约日期" show-overflow-tooltip prop="enterDate"></el-table-column>
      <el-table-column label="预约入园时间段" show-overflow-tooltip prop="time"></el-table-column>
      <!-- <el-table-column label="健康码" show-overflow-tooltip prop="recordStatus">
        <template v-slot="{ row }">
          <span :style="{ color: row.recordStatus === '1' ? '#F01919' : '#1AD1B0' }">{{ row.recordStatus | filterHealth
          }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="预约结果" show-overflow-tooltip prop="recordStatus">
        <template v-slot="{ row }">
          {{ row.recordStatus | filterState }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="110px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.recordId)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
    <TouristDialogDetail v-if="isShowType" :isShowType.sync='isShowType' :id="id"></TouristDialogDetail>
  </el-card>
</template>

<script>
import TouristDialogDetail from './TouristDialogDetail'
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Tourist',
  mixins: [keepAlive],
  components: {
    TouristDialogDetail
  },
  filters: {
    filterState: function (value) {
      switch (value) {
        case '0': return '预约成功'
        case '1': return '预约失败'
        case '2': return '预约取消'
        default: return '--'
      }
    },
    filterHealth: function (value) {
      switch (value) {
        case '1': return '异常'
        default: return '正常'
      }
    }
  },
  data() {
    return {
      dateRange: [this.$route.query.startTime || '', this.$route.query.endTime || ''],
      info: {
        projectId: this.$route.query.projectId || '',
        recordStatus: '',
        startTime: this.$route.query.startTime || '',
        endTime: this.$route.query.endTime || '',
        itemId: ''
      },
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      isShowType: false,
      id: '',
      parkList: [],
      appointList: [],
      count: 0
    }
  },
  created() {
    this.loadData()
    this.getPark()
    this.selectEnterNumTotal()
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    selectAppoint() {
      if (this.info.projectId) {
        this.getAppointItem()
      } else {
        this.info.itemId = ''
        this.appointList = []
      }
    },
    // 获取项目
    getAppointItem() {
      this.$axios.get(this.$apis.tourist.selectAppointItemList, {
        projectId: this.info.projectId
      }).then(res => {
        console.log(res, '游客');
        this.appointList = res || []
      })
    },
    // 查询对象总和
    selectEnterNumTotal() {
      this.$axios.get(this.$apis.tourist.selectEnterNumTotal, {
        ...this.info
      }).then(res => {
        this.count = res || 0
      })
    },
    loadData() {
      this.loading = true
      if (this.dateRange) {
        this.info.startTime = this.dateRange[0] || ''
        this.info.endTime = this.dateRange[1] || ''
      } else {
        this.info.startTime = ''
        this.info.endTime = ''
      }
      const params = {
        ...this.info,
        page: this.page,
        size: this.size
      }
      this.$axios.get(this.$apis.tourist.selectAppointItemRecordByPage, {
        ...params
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
      this.selectEnterNumTotal()
    },
    onDetail(recordId) {
      this.isShowType = true
      this.id = recordId
    }
  }
}
</script>

<style scoped lang="scss">
.tips {
  height: 40px;
  background: #FBFBFB;
  border: 1px solid #EBEBEB;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #565656;

  i {
    color: #00D5AF;
    margin-right: 5px;
  }
}
</style>
